import React from 'react'
import './Plans.css'
import Bestoffer from "../../imgs/bestoffer.png";
import Correct from "../../imgs/correct.png";
import Back from "../../imgs/backexam.png";
import { useLocation, useNavigate } from 'react-router-dom';

const Plans = () => {
    const navigate = useNavigate();

    const backtohome = ()=>{
        navigate('/Dashboard');
    }

    return (
        <div className='plans'>
            <div className="whiteboxplans">
                <div className="toprowplans">
                    <div className="firstrowplans">
                        <img onClick={backtohome} className='backimg' src={Back} alt="" />
                        <img className='planimg' src={Bestoffer} alt="" />
                    </div>
                    
                    <div className="planrow">
                        <div className="plan">
                            <span className='first'>for Class 1 to Class 12 Students</span>
                            <div className='line' />
                            <span className='rs'>Rs.900/-</span>
                            <span className='third'>For Students</span>
                            <div className="detailsplan">
                                <div className="plandetails">
                                    <div className="plandetailsrow">
                                        <img src={Correct} alt="" />
                                        <span>Free Practice Test</span>
                                    </div>
                                    <div className="plandetailsrow">
                                        <img src={Correct} alt="" />
                                        <span>Unlimited access</span>
                                    </div>
                                    <div className="plandetailsrow">
                                        <img src={Correct} alt="" />
                                        <span>Basic to advanced</span>
                                    </div>
                                </div>
                            </div>
                            <div className="buttonpay">
                                PAY &  START TEST
                            </div>
                        </div>

                        <div className="plan">
                            <span className='first'>for UG,PG and Professionals</span>
                            <div className='line' />
                            <span className='rs'>Rs.900/-</span>
                            <span className='third'>For Students</span>
                            <div className="detailsplan">
                                <div className="plandetails">
                                    <div className="plandetailsrow">
                                        <img src={Correct} alt="" />
                                        <span>Free Practice Test</span>
                                    </div>
                                    <div className="plandetailsrow">
                                        <img src={Correct} alt="" />
                                        <span>Unlimited access</span>
                                    </div>
                                    <div className="plandetailsrow">
                                        <img src={Correct} alt="" />
                                        <span>Basic to advanced</span>
                                    </div>
                                </div>
                            </div>
                            <div className="buttonpay">
                                PAY &  START TEST
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Plans
